import React from "react";
import "../../styles/components-styles/question-components-styles/QuestionBody-style.css";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import QuestionDropDown from "./QuestionDropDown";
import { Hammer } from "lucide-react";
import RecentSessions from "./RecentSessions";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log("totally custom!")
  );

  return (
    <button type="button" onClick={decoratedOnClick}>
      {children}
    </button>
  );
}

const QuestionBody = () => {
  return (
    <div className="container">
      <div className="cat-row">
        <div className="catergories">
          <h5>Catergories</h5>
          <hr />
          <ul>
            <li className="Qlist-items">
              <p>
                {" "}
                <input type="checkbox" name="" id="" />
                All
              </p>
              <p>Attempted 4,444 of 4,695</p>
            </li>
            <li className="Qlist-items">
              <p>
                {" "}
                <input type="checkbox" name="" id="" />
                Administration and health infomatics
              </p>
              <p>146 of 165</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" />
                Dermatology
              </p>
              <p>407 of 416</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" /> Ear, nose and throat
              </p>
              <p>155 of 164</p>
            </li>
            <li className="Qlist-items">
              <p>
                {" "}
                <input type="checkbox" name="" id="" />
                Evidence based clinical practice
              </p>
              <p>252 of 300</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" />
                Medicine
              </p>
              <p>1,778 of 1,866</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" />
                Ophthalmology
              </p>
              <p>144 of 145</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" />
                Paediatrics
              </p>
              <p>471 of 474</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" />
                Psychiatry
              </p>
              <p>203 of 203</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" />
                Surgical and musculoskeletal problems
              </p>
              <p>400 of 458</p>
            </li>
            <li className="Qlist-items">
              <p>
                <input type="checkbox" name="" id="" />
                Women's health
              </p>
              <p>488 of 504</p>
            </li>
          </ul>
        </div>

        <div className="difficulty">
          <h5>Difficulty</h5>
          <hr />
          <div className="difficulty-list">
            <div>
              <input type="radio" name="" id="" />
              <Hammer />
            </div>
            <div>
              <input type="radio" name="" id="" />
              <Hammer />
              <Hammer />
            </div>
            <div>
              <input type="radio" name="" id="" />
              <Hammer />
              <Hammer />
              <Hammer />
            </div>
          </div>
        </div>

        {/* <div className="question-select">
          <h5>QUESTION SELECTION</h5>
          <QuestionDropDown />
        </div>

        <div className="optimise">
          <h5>QUESTION ORDER OPTIMISATION</h5>
          <hr />
          <p >
           
            Optimise question order
            <Accordion defaultActiveKey="0">
              <CustomToggle eventKey="1">Click me!</CustomToggle>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  Questions are ususally displayed to you in a random order. For
                  many users, this may not be the optimal way to spend their
                  revision time. As you answer questions, PassMedicine builds an
                  internal model of your knowledge - what you know and don't
                  know broken down by key concepts, topics and categories. The
                  optimisation algorithm uses this data to determine the order
                  of the questions. You can view your own model here Factors
                  taken into account by our algorithms include: Previous key
                  concept performance - we sometimes test an important concept
                  more than once - if you've got a question associated with this
                  concept wrong previously the algorithm will prioritise you
                  seeing a related question, using the principles of spaced
                  repetition to improve retention Key concept importance - the
                  algorithm will priortise questions linked to concepts rated as
                  very important Previous topic performance - this is a broader
                  marker than key concept performance, for example, if you've
                  got a number of questions wrong about anaemia in chronic
                  kidney disease the algorithm will show you more Question
                  difficulty - we'll prioritise showing you questions pitched
                  right at your level, challenging but not too hard After you've
                  attempted a question, you can view some of the reasons why a
                  question was prioritised by clicking on the AI symbol
                  displayed below the question. Using optimisation mode is
                  particularly beneficial towards the end of your revision as
                  the system has lots of data to base the recommendations on.
                  The algorithms will constantly update the recommendations as
                  you progress throught the question bank.
                </Card.Body>
              </Accordion.Collapse>
            </Accordion>
          </p>
        </div> */}
      </div>
      <div className="recent-sessions">
        <RecentSessions />
      </div>
    </div>
  );
};

export default QuestionBody;
